module.exports = __webpack_public_path__ + "static/media/mito14.617530a6.jpg";